<template>
    <div class="popup show-popup zzv-popup">
        <div class="popup-content">
            <div class="close-button" v-on:click="showCustom(3)">X</div>
            <p class="first">So inštrukcije predrage?</p>
            <p>Naroči interaktivno vadnico!</p>
            <p class="hide"><input type="checkbox" name="zzv-popup" value="true" ref="cookie-check" id="zzv-popup" v-on:click="checkboxClicked()"> <label for="zzv-popup">Tega sporočila ne kaži več.</label></p>
            <p class="bottom">
                <a href="https://www.znamzavec.si/" target="_blank"><button class="button blue" v-on:click="dontShowAnymore()"><span>VEČ</span></button></a>
                <button class="button white" v-on:click="dontShowAnymore()"><span>NE ZANIMA ME</span></button>
            </p>
        </div>
    </div>
</template>

<script>
    import popup from '../popup.js'

    export default {
        props: ['data'],
        mixins: [popup]
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PopupZzv.vue